import React, { Component } from "react";

export default class Header extends Component {
	

	handleRouteToHome = () => {
		this.props.history.push('/')
	}

	componentDidMount(){
		let logo = document.querySelector(".logo");
		logo.focus();
		document.addEventListener('keyup',this.closeKeyUp);
	}

	keyUp=(e)=>{
		if(e.keyCode===13){
			this.props.toggleBox();
		}
	}
	closeKeyUp= (e) => {
		if(e.keyCode===27){
        	this.props.closeBox();
		}
	}

	render() {
		return (
			<div className="SiteHeader">
				<div className="dx-col">
					<div className="logo-area">
						<div className="dx-col">

							<div className="logo" onClick={this.handleRouteToHome} tabIndex="0">
							<img src="/media/icons/PCS-Logo-RGB-2COL-WHI-GOLD.png" alt="PCS Brand - Navigate to Welcome Screen"/>

							</div>
							<div className="logo-title">
								Private Client Group
							</div>
						</div>
					</div>
					
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atomic/pages/MaintenancePage/MaintenanceHeader/Header/Header.js